import React, { useCallback, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useMatch } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import FormInput from '../../components/FormInput';
import FormLabel from '../../components/FormLabel';
import SimpleButton from '../../components/SimpleButton';
import Spacer from '../../components/Spacer';
import { IApplicationState } from '../../store';
import { usersDraftUpdate, usersSaveRequest } from '../../store/users/slice';
import { IUser } from '../../store/users/types';
import { Container } from './styles';

const UserForm: React.FC = (props) => {
    const route = useMatch('/user/:idUser/form');

    const { t } = useTranslation();

    const idUser = route?.params.idUser

    const user = useSelector((state: IApplicationState) => state.users.data.find((user) => user.id === idUser));

    const users = useSelector((state: IApplicationState) => state.users);

    const dispatch = useDispatch();

    const [isLoaded, setIsLoaded] = useState(false)

    const editingUser = users.draftUser;

    const setEditingUser = useCallback((user: IUser) => {
        dispatch(usersDraftUpdate(user))
    }, [dispatch]);

    useEffect(() => {
        if (user && !isLoaded) {
            setEditingUser({
                ...user,
                error: undefined,
            });
            setIsLoaded(true);
        }
    }, [user, isLoaded, setEditingUser]);

    if (!editingUser) {
        return (
            <Container>
                <h1>{t("pages.users.not_found_form")}</h1>
            </Container>
        );
    }

    return <Container>
        <h1>
            {editingUser.id
                ? t("pages.users.edit_user")
                : t("pages.users.create_user")}
        </h1>

        <FormLabel>{t("pages.users.name")}</FormLabel>
        <FormInput
            value={editingUser.name || ""}
            onChangeText={(text) => {
                setEditingUser({
                    ...editingUser,
                    name: text
                })
            }}
        />

        <FormLabel>{t("pages.users.email")}</FormLabel>
        <FormInput
            value={editingUser.email || ""}
            onChangeText={(text) => {
                setEditingUser({
                    ...editingUser,
                    email: text
                })
            }}
        />

        <FormLabel>{t("pages.users.password")}</FormLabel>
        <FormInput
            type="password"
            value={editingUser?.password || ""}
            onChangeText={(text) => {
                setEditingUser({
                    ...editingUser,
                    password: text
                })
            }}
        />


        <Spacer size={20} />

        <SimpleButton
            prependIcon='save'
            color='primary'
            disabled={editingUser?.isSaving || users.isLoading}
            onClick={() => {
                dispatch(usersSaveRequest(editingUser))

            }}
        >
            {editingUser?.isSaving ? `${t("common.buttons.saving")}...` : t("common.buttons.save")}

        </SimpleButton>

        <Spacer size={20} />

        {editingUser?.error && <React.Fragment>
            <ErrorMessage>{editingUser.error.message}</ErrorMessage>
            <Spacer size={20} />
        </React.Fragment>}
    </Container>;
}

export default UserForm;